module.exports = __webpack_public_path__ + "56a541a970d1bdb27425850a99d3fc3d.svg";